import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSelect } from '@app/components/common/selects/BaseSelect/BaseSelect';
import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { DropdownOption } from '@app/models/DropdownOption';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';

type ExportInfoProps = {
  editable: boolean;
  status: string | null;
  acceptedFields: any;
  productCategories: DropdownOption[];
  department_options: DropdownOption[];
  country_options: DropdownOption[];
  // location_options: DropdownOption[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  setAcceptedFields: Function;
  form: any;
  exportData: any;
  editableUser: any;
};

const ExportInfo: React.FC<ExportInfoProps> = ({
  editable,
  productCategories,
  status,
  acceptedFields = {},
  editableUser,
  country_options,
  // location_options,
  department_options,

  setAcceptedFields,
  form,
  exportData,
}) => {
  const [disabledButtons, setDisabledButtons] = useState<Record<string, boolean>>({});
  const [visibleButtons, setButtonVisibility] = useState<Record<string, string>>({});
  const [departmentOptions, setDepartmentOptions] = useState<DropdownOption[]>(department_options);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const currentUser = user?.usertype || 'Unknown User';
  const canEdit = editable && currentUser === 'CUSTOMER';

  useEffect(() => {
    const importType = localStorage.getItem('importType');
    if (importType && !form.getFieldValue('type')) {
      form.setFieldsValue({ type: importType });
    }
  }, [form]);

  useEffect(() => {
    if (exportData) {
      const selectedDeptId = exportData.department_id;
      const selectedDeptName = exportData.department?.name || 'Unknown Department';

      if (selectedDeptId && !departmentOptions.some((opt) => opt.value === selectedDeptId)) {
        setDepartmentOptions((prev) => [...prev, { value: selectedDeptId, label: selectedDeptName }]);
      }
      form.setFieldsValue({
        code: exportData?.reference_code || '',
        type: exportData?.type || '',
        // location_id: exportData?.location_id || '',
        department_id: exportData?.department_id || '',
        expire_date: exportData?.expire_date || '',
        product_reg_type: exportData?.product_reg_type || '',
        product_category_id: exportData?.product_category_id || '',
        allowed_weightage: exportData?.allowed_weightage || '',
        // quantity: exportData?.quantity || '',
        country_id: exportData?.country_id || '',
        consignment_status: exportData?.consignment_status || '',
        consignment_type: 'Export',
      });

      setAcceptedFields(exportData.accepted || {});
    }
  }, [form, exportData, departmentOptions, setAcceptedFields]);
  useEffect(() => {
    if (!form.getFieldValue('type')) {
      const exportType = localStorage.getItem('exportType');
      if (exportType) {
        form.setFieldsValue({ type: exportType });
      }
    }
  }, [form]);

  const fields: any = [
    // {
    //   name: 'code',
    //   label: 'Reference Code',
    //   component: editable ? (
    //     <Input.Group compact style={{ display: 'flex', width: '100%' }}>
    //       <Input
    //         style={{ width: '100%' }}
    //         value={form.getFieldValue('code')}
    //         onChange={(e) => form.setFieldsValue({ code: e.target.value })}
    //         placeholder="Enter Code"
    //       />
    //     </Input.Group>
    //   ) : (
    //     <BaseInput readOnly value={form.getFieldValue('code')} />
    //   ),
    // },
    {
      name: 'type',
      label: 'Type',
      component: <BaseInput readOnly value={form.getFieldValue('type') ?? ''} />,
    },
    {
      name: 'expire_date',
      label: 'Intended Date of Export',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <DatePicker
            style={{ width: '100%' }}
            value={form.getFieldValue('expire_date') ? moment(form.getFieldValue('expire_date')) : null}
            onChange={(date) => {
              // Format the date to 'YYYY-MM-DD HH:mm:ss' format before saving it
              const formattedDate = date ? date.format('YYYY-MM-DD HH:mm:ss') : null;
              form.setFieldsValue({ expire_date: formattedDate });
            }}
            placeholder="Select Intended Date of Export"
          />
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('expire_date')} />
      ),
    },
    {
      name: 'product_reg_type',
      label: 'Product Registration Type',
      component: canEdit ? (
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            type={form.getFieldValue('product_reg_type') === 'ENTITY' ? 'primary' : 'default'}
            onClick={() => form.setFieldsValue({ product_reg_type: 'ENTITY' })}
          >
            Entity Registration
          </Button>
          <Button
            type={form.getFieldValue('product_reg_type') === 'EXPORTER' ? 'primary' : 'default'}
            onClick={() => form.setFieldsValue({ product_reg_type: 'EXPORTER' })}
          >
            Exporter Registration
          </Button>
        </div>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('product_reg_type')} />
      ),
    },

    // {
    //   name: 'quantity',
    //   label: 'Quantity',
    //   component: editable ? (
    //     <Input.Group compact style={{ display: 'flex', width: '100%' }}>
    //       <Input
    //         style={{ width: '100%' }}
    //         value={form.getFieldValue('quantity')}
    //         onChange={(e) => form.setFieldsValue({ quantity: e.target.value })}
    //         placeholder="Enter Quantity"
    //       />
    //     </Input.Group>
    //   ) : (
    //     <BaseInput readOnly value={form.getFieldValue('quantity')} />
    //   ),
    // },
    {
      name: 'allowed_weightage',
      label: 'Allowed Weightage',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <Input
            style={{ width: '100%' }}
            value={form.getFieldValue('allowed_weightage')}
            onChange={(e) => form.setFieldsValue({ allowed_weightage: e.target.value })}
            placeholder="Enter Allowed Weightage"
          />
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('allowed_weightage')} />
      ),
    },
    {
      name: 'consignment_status',
      label: 'Consignment Status',
      component: canEdit ? (
        <Input.Group compact style={{ display: 'flex', width: '100%' }}>
          <Select
            style={{ width: '100%' }}
            value={form.getFieldValue('consignment_status')}
            onChange={(value) => form.setFieldsValue({ consignment_status: value })}
            placeholder="Select Consignment Status"
          >
            <Select.Option value="PARTIAL_ARRIVAL">Partial Arrival</Select.Option>
            <Select.Option value="FULL_SHIPMENT">Full Shipment</Select.Option>
          </Select>
        </Input.Group>
      ) : (
        <BaseInput readOnly value={form.getFieldValue('consignment_status')} />
      ),
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Consignment Category</Space>}
          name="product_category_id"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                allowClear
                placeholder="Select Product Category"
                disabled={!canEdit}
                options={productCategories}
                style={{ width: '100%' }}
                value={form.getFieldValue('product_category_id')}
                onChange={(value) => form.setFieldsValue({ product_category_id: value })}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  productCategories?.find((category) => category.value === form.getFieldValue('product_category_id'))
                    ?.label || 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Country of Destination</Space>}
          name="country_id"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                allowClear
                showSearch
                placeholder="Select Country"
                disabled={!canEdit || !!acceptedFields['country_id']}
                options={country_options}
                style={{ width: '100%' }}
                value={form.getFieldValue('country_id')}
                onChange={(value) => form.setFieldsValue({ country_id: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('country_id')
                    ? country_options.find((country) => country.value === form.getFieldValue('country_id'))?.label ||
                      'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      {/* <BaseCol xs={24} md={12}>
        <Form.Item label={<Space style={{ display: 'flex', alignItems: 'center' }}>Location</Space>} name="location_id">
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {editable ? (
              <BaseSelect
                allowClear
                showSearch // 🔥 make it searchable
                placeholder="Select Location"
                disabled={!editable || !!acceptedFields['location_id']}
                options={location_options}
                style={{ width: '100%' }}
                value={form.getFieldValue('location_id')}
                onChange={(value) => form.setFieldsValue({ location_id: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('location_id')
                    ? location_options.find((location) => location.value === form.getFieldValue('location_id'))
                        ?.label || 'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol> */}

      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Department</Space>}
          name="department_id"
        >
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            {canEdit ? (
              <BaseSelect
                allowClear
                showSearch
                placeholder="Select Department"
                disabled={!canEdit || !!acceptedFields['department_id']}
                options={departmentOptions}
                style={{ width: '100%' }}
                value={form.getFieldValue('department_id')}
                onChange={(value) => form.setFieldsValue({ department_id: value })}
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              />
            ) : (
              <BaseInput
                readOnly
                value={
                  form.getFieldValue('department_id')
                    ? departmentOptions.find((department) => department.value === form.getFieldValue('department_id'))
                        ?.label || 'Not Selected'
                    : 'Not Selected'
                }
              />
            )}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      <BaseCol xs={24} md={12}>
        <Form.Item
          label={<Space style={{ display: 'flex', alignItems: 'center' }}>Consignment Type</Space>}
          name="consignment_type"
        >
          {/* This is where the fixed "Import" value will be displayed in view mode */}
          <Input.Group compact style={{ display: 'flex', width: '100%' }}>
            <BaseInput readOnly value="Export" /> {/* Fixed value "Import" */}
          </Input.Group>
        </Form.Item>
      </BaseCol>

      {fields?.map((e: any) => (
        <React.Fragment key={e.name}>
          <Col xs={24} md={12}>
            <Form.Item
              name={e?.name}
              label={<Space style={{ display: 'flex', alignItems: 'center' }}>{e?.label}</Space>}
            >
              {e?.component}
            </Form.Item>
          </Col>
        </React.Fragment>
      ))}
    </Row>
  );
};

export default ExportInfo;
